import Logo from "@/assets/svg/full-logo/creator-shield.svg";
import {
  CSPrimaryBtn,
  CSTertiaryBtn,
} from "@/components/design-system/creatorshield/CSButton";
import { useIsMobile } from "@/hooks/use-mobile";
import { ArrowRight, Menu, X, Zap } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

export default function CreatorshieldNavbar() {
  const isMobile = useIsMobile();
  const location = useLocation();

  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      setLastScrollY(window.scrollY);
      setIsAtTop(window.scrollY === 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div>
         {/* Top Banner */}
         <div
        className={`${
          location.pathname === "/live"
            ? "bg-[#9333EA]"
            : location.pathname === "/success-stories"
              ? "bg-[#16A34A]"
              : "bg-[#FF6B35]"
        } text-white text-xs lg:text-sm py-2 px-6 text-left lg:text-center fixed top-0 left-0 right-0 z-[60] overflow-hidden`}
      >
        {/* Mobile - Carousel */}
        <div className="lg:hidden relative h-[20px]">
          <div className="absolute whitespace-nowrap animate-marquee">
            <span className="inline-flex items-center gap-2 mr-8">
              <Zap size={15} className="fill-white" />
              CreatorShield protects the #1 most viewed short video in YouTube.{" "}
              <Link to="/case-study" className="underline hover:no-underline">
                Read more →
              </Link>
              <Zap size={15} className="fill-white" />
            </span>
            <span className="inline-flex items-center gap-2 mr-8">
              <Zap size={15} className="fill-white" />
              CreatorShield protects the #1 most viewed short video in YouTube.{" "}
              <Link to="/case-study" className="underline hover:no-underline">
                Read more →
              </Link>
              <Zap size={15} className="fill-white" />
            </span>
          </div>
        </div>

        {/* Desktop - Static */}
        <p className="hidden lg:flex items-center justify-center gap-2">
        <Zap size={15} className="fill-white" />
              CreatorShield protects the #1 most viewed short video in YouTube.{" "}
              <div className="flex items-center gap-1 hover:underline">
                <Link to="/case-study">Read more</Link>
                <ArrowRight size={15} />
              </div>
              <Zap size={15} className="fill-white" />
        </p>
      </div>
      {/* Navbar */}
      <div
         className={`${
          isAtTop ? "bg-white" : "bg-white shadow-md"
        } fixed top-[33px] left-0 right-0 transition-transform duration-300 z-50 ${
          showNavbar ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="4xl:max-w-[100rem] 4xl:mx-auto">
          <div className="py-3 px-6 lg:px-16 flex justify-between items-center relative">
            <Link to="/" className="flex items-center gap-2 z-10">
              <img src={Logo} alt="Creatorshield Logo" className="w-44" />
            </Link>

            {/* Desktop Links - Centered */}
            <div className="hidden lg:flex gap-8 text-black items-center absolute left-1/2 transform -translate-x-1/2">
              <Link to="/" className="hover:text-[#FF6B35] transition-colors">
                Home
              </Link>
              <Link to="/live" className="flex items-center gap-[5px]">
                <span className="hover:text-[#FF6B35] transition-colors">
                  CreatorShield
                </span>
                <div className="bg-[#ff2a23] text-white px-[10px] py-[2px] rounded-full flex items-center justify-center gap-[2px]">
                  <span className="text-xs">•</span>
                  <span className="text-xs font-normal whitespace-nowrap">
                    Live
                  </span>
                </div>
              </Link>
              <Link
                to="/success-stories"
                className="hover:text-[#FF6B35] transition-colors"
              >
                Success Stories
              </Link>
              <Link
                to="/faq"
                className="hover:text-[#FF6B35] transition-colors"
              >
                F.A.Qs
              </Link>
              <Link
                to="/contact-us"
                className="hover:text-[#FF6B35] transition-colors"
              >
                Contact
              </Link>
            </div>

            {/* Desktop Buttons */}
            <div className="hidden lg:flex items-center gap-4 z-10">
            <a
                  href="https://app.creatorshield.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <CSTertiaryBtn className="w-[135px]" name="Sign in" />
                </a>
              <Link to="/esign">
                <CSPrimaryBtn name="Sign up today" />
              </Link>
            </div>

            {/* Mobile Toggle */}
            <button
              className="lg:hidden text-black z-10"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? (
                <X size={28} className="text-black" />
              ) : (
                <Menu size={28} className="text-black" />
              )}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden bg-white flex flex-col gap-6 px-6 py-8 border-t">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
                Home
              </Link>
              <Link
                to="/live"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center gap-[5px]"
              >
                <span className="text-black">CreatorShield</span>
                <div className="bg-[#ff2a23] text-white px-[10px] py-[2px] rounded-[100px] flex items-center justify-center gap-[2px]">
                  <span className="text-xs">•</span>
                  <span className="text-xs font-normal whitespace-nowrap">
                    Live
                  </span>
                </div>
              </Link>
              <Link
                to="/success-stories"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Success Stories
              </Link>
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)}>
                F.A.Qs
              </Link>
              <Link to="/contact-us" onClick={() => setIsMobileMenuOpen(false)}>
                Contact
              </Link>
              <div className="flex flex-col gap-4 mt-4">
                <a
                  href="https://app.creatorshield.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <CSTertiaryBtn name="Sign in" className="w-full" />
                </a>
                <Link to="/esign" onClick={() => setIsMobileMenuOpen(false)}>
                  <CSPrimaryBtn name="Sign Up Today" className="w-full" />
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>

      <Outlet />
    </div>
  );
}
